export default __webpack_public_path__ + "static/media/1.60acda29.png";